import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import PropTypes from "prop-types";

export function CSFPivotalBrokerPasswordChange({apiUrl, apiEnv, type}) {
  const [input, setInput] = useState({
    changePasswordFormEmailInput: '',
    changePasswordFormPwdInput: '',
    changePasswordFormPwdConfInput: '',
  });

  const [label, setLabel] = useState({
    email: type === 'member' ? window.Drupal.t('membre.login.username.label') : window.Drupal.t('broker.resetPassword'),
    pwd: window.Drupal.t('New password'),
    pwdConfirmed: window.Drupal.t('Confirm new password'),
  });

  const [error, setError] = useState({
    email: '',
    pwd: '',
    pwdConfirmed: '',
  });
  const queryParameters = new URLSearchParams(window.location.search);
  const token = queryParameters.get('token');
  const [successSubmit, setSuccessSubmit] = useState();
  const [isSamePwd, setIsSamePwd] = useState(false);
  const [formValidated, setFormValidated] = useState(false);

  function handleChange(evt) {
    const value = evt.target.value;
    setInput({
      ...input,
      [evt.target.name]: value,
    });

    switch (evt.target.name) {
      case 'changePasswordFormEmailInput':
        if (value.length && isSamePwd) {
          setFormValidated(true);
        } else {
          setFormValidated(false);
        }
        break;
      case 'changePasswordFormPwdInput':
        if (value !== input.changePasswordFormPwdConfInput && input.changePasswordFormPwdConfInput.length) {
          setError({ ...error, ['pwdConfirmed']: window.Drupal.t('csf_api_pivotal.broker.password_dont_match') });
          setIsSamePwd(false);
          setFormValidated(false);
        } else {
          setError({ ...error, ['pwdConfirmed']: '' });
          if (value.length && input.changePasswordFormPwdConfInput.length) {
            setIsSamePwd(true);
            if (input.changePasswordFormEmailInput.length) {
              setFormValidated(true);
            } else {
              setFormValidated(false);
            }
          }
        }
        break;

      case 'changePasswordFormPwdConfInput':
        if (value !== input.changePasswordFormPwdInput && input.changePasswordFormPwdInput.length && value.length) {
          setError({ ...error, ['pwdConfirmed']: window.Drupal.t('csf_api_pivotal.broker.password_dont_match') });
          setIsSamePwd(false);
          setFormValidated(false);
        } else {
          setError({ ...error, ['pwdConfirmed']: '' });
          if (value.length && input.changePasswordFormPwdInput.length) {
            setIsSamePwd(true);
            if (input.changePasswordFormEmailInput.length) {
              setFormValidated(true);
            } else {
              setFormValidated(false);
            }
          }
        }
        break;

      default:
        break;
    }

  }

  const _getFormFieldWrapperClasses = function () {
    return 'js-form-item form-item js-form-type-password form-item-pass js-form-item-pass form-group';
  };

  function displaySuccessSubmit() {
    setSuccessSubmit(
      <div className="messagebox py-1 px-2 px-md-5 messagebox-success">
        <div className="grid-container-large">
          <div className="d-flex flex-column flex-lg-row align-items-center">
            <p className="messagebox-text mb-0"
               dangerouslySetInnerHTML={{ __html: window.Drupal.t('csf_api_pivotal.broker.password_changed') }}>
            </p>
          </div>
        </div>
      </div>,
    );
  }

  function displayFailureSubmit(data) {
    let errorMessage = window.Drupal.t('csf_api_pivotal.broker.password_change_failure.message');

    if (data && data.errorText && data.errorText === "PasswordRules_TooShort") {
      errorMessage = window.Drupal.t('csf_api_pivotal.broker.password_change_failure.PasswordRules_TooShort.message');
    }

    setSuccessSubmit(
      <div className="messagebox py-1 px-2 px-md-5 messagebox-error">
        <div className="grid-container-large">
          <div className="d-flex flex-column flex-lg-row align-items-center">
            <p className="messagebox-text mb-0"
               dangerouslySetInnerHTML={{ __html: errorMessage }}>
            </p>
          </div>
        </div>
      </div>,
    );
  }

  function startLoadingSpinner() {
    // spinner markup is already in pages
    const background = document.querySelectorAll('.ui-loader-background');
    const loader = document.querySelectorAll('#loader');

    if (background !== undefined && background !== null) {
      if (loader !== undefined && loader !== null) {
        background[0].style.display = 'block';
        loader[0].style.visibility = 'visible';
      }
    }
  }

  function stopLoadingSpinner() {
    // spinner markup is already in pages
    const background = document.querySelectorAll('.ui-loader-background');
    const loader = document.querySelectorAll('#loader');

    if (background !== undefined && background !== null) {
      if (loader !== undefined && loader !== null) {
        background[0].style.display = 'none';
        loader[0].style.visibility = 'hidden';
      }
    }
  }

  function bytesToBase64(bytes) {
    const binString = Array.from(bytes, (x) => String.fromCodePoint(x)).join("");
    return btoa(binString);
  }

  function handleSubmit(event) {
    if (!formValidated) {
      return;
    }

    event.preventDefault();

    //Show spinner
    startLoadingSpinner();

    // base64 encoding of unicode string data:
    // https://developer.mozilla.org/en-US/docs/Glossary/Base64
    let base64NewPassword = bytesToBase64(new TextEncoder()
      .encode(input.changePasswordFormPwdInput));

    const recipeUrl = apiUrl;
    const postBody = {
      userName: input.changePasswordFormEmailInput,
      password: base64NewPassword,
      token: token,
      options: 'pb',
    };

    const requestMetadata = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'pivotalEnvironmentName': apiEnv,
      },
      body: JSON.stringify(postBody),
    };

    fetch(recipeUrl, requestMetadata)
      .then(res => res.json())
      .then(data => {
        if(data.success) {
          displaySuccessSubmit();
        } else {
          // could not change password
          displayFailureSubmit(data);
        }

        stopLoadingSpinner();
      })
      .catch(function (error) {
        // could not change password
        displayFailureSubmit(null);
        stopLoadingSpinner();
      });
  }

  return (
    <form className="broker-password-reset-form" autoComplete="on"
          onSubmit={handleSubmit}>

      {successSubmit}

      <div className={_getFormFieldWrapperClasses()}>
        <label htmlFor="changePasswordFormEmailInput"
               className="js-form-required form-required">
          {label.email}
        </label>
        <input autoCorrect="none" autoCapitalize="none" spellCheck="false"
               type="email"
               id="changePasswordFormEmailInput"
               name="changePasswordFormEmailInput"
               defaultValue={input.changePasswordFormEmailInput}
               onChange={handleChange}
               size="15" maxLength="60"
               className="form-text required" required="required"
               aria-required="true"/>
        {error.email &&
          <div className="form-item--error-message"> {error.email} </div>}
      </div>

      <div
        className={_getFormFieldWrapperClasses()}>
        <label htmlFor="changePasswordFormPwdInput"
               className="js-form-required form-required">
          {label.pwd}
        </label>
        <div className="field__password input-container-max-width">
          <input data-drupal-selector="edit-pass" type="password"
                 id="changePasswordFormPwdInput"
                 name="changePasswordFormPwdInput"
                 size="15" maxLength="128"
                 defaultValue={input.changePasswordFormPwdInput}
                 onChange={handleChange}
                 className="form-text required" required="required"
                 aria-required="true"/>
          {error.pwd &&
            <div className="form-item--error-message"> {error.pwd} </div>}
          <a className="togglepass">
            <span className="passIcon hidePass">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512">{/* Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. */}
                <path
                  d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z"></path></svg></span>
            <span className="passIcon showPass" style={{ display: 'none' }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512">{/* Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. */}
                <path
                  d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c5.2-11.8 8-24.8 8-38.5c0-53-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zm223.1 298L373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5z"></path></svg></span>
          </a>
        </div>
      </div>

      <div
        className={_getFormFieldWrapperClasses()}>
        <label htmlFor="changePasswordFormPwdConfInput"
               className="js-form-required form-required">
          {label.pwdConfirmed}
        </label>
        <div className="field__password input-container-max-width">
          <input data-drupal-selector="edit-pass" type="password"
                 id="changePasswordFormPwdConfInput"
                 name="changePasswordFormPwdConfInput"
                 size="15" maxLength="128"
                 defaultValue={input.changePasswordFormPwdConfInput}
                 onChange={handleChange}
                 className="form-text required" required="required"
                 aria-required="true"/>
          {error.pwdConfirmed && <div
            className="form-item--error-message"> {error.pwdConfirmed} </div>}

          <a className="togglepass">
            <span className="passIcon hidePass">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512">{/* Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. */}
                <path
                  d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z"></path></svg></span>
            <span className="passIcon showPass" style={{ display: 'none' }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512">{/* Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. */}
                <path
                  d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c5.2-11.8 8-24.8 8-38.5c0-53-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zm223.1 298L373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5z"></path></svg></span>
          </a>
        </div>
      </div>

      <div data-drupal-selector="edit-actions"
           className="form-actions js-form-wrapper form-wrapper"
           id="edit-actions">
        <input type="submit"
               disabled={!formValidated}
               name="op"
               value={window.Drupal.t('Submit')}
               className="button js-form-submit form-submit btn-primary btn"/>
      </div>
    </form>
  );
}

window.addEventListener('DOMContentLoaded', () => {

  const domNode = document.getElementById('CSFPivotalBrokerPasswordChange');

  if (domNode !== null) {
    const root = createRoot(domNode);
    const apiUrl = domNode.getAttribute('data-api-url');
    const apiEnv = domNode.getAttribute('data-api-env');
    const type = domNode.getAttribute('data-type') ?? '';

    root.render(<CSFPivotalBrokerPasswordChange
      apiUrl={apiUrl}
      apiEnv={apiEnv}
      type={type}
    />);
  }

});

CSFPivotalBrokerPasswordChange.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  type: PropTypes.string,
};
